import { Outlet, Link, useLocation } from "react-router";
import { useAuth } from "@/contexts/AuthContext";
import LogoutButton from "@/components/auth/LogoutButton";
import { ConfirmProvider } from "@/components/admin/ConfirmDialog";
import SEO from "@/components/seo/SEO";
import {
  LayoutDashboard,
  Layers,
  Settings,
  FolderKanban,
  Image,
  FileText,
} from "lucide-react";

export default function AdminLayout() {
  const { user } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: "/admin", label: "Dashboard", icon: LayoutDashboard },
    { path: "/admin/hero", label: "Hero Slides", icon: Image },
    { path: "/admin/skills", label: "Skills", icon: Layers },
    { path: "/admin/projects", label: "Projects", icon: FolderKanban },
    { path: "/admin/settings", label: "Settings", icon: Settings },
    { path: "/admin/blog", label: "Blog", icon: FileText },
  ];

  return (
    <ConfirmProvider>
      <SEO title="Admin" noindex />
      <div className="min-h-screen bg-gray-50 admin-page">
        <style>{`
          .admin-page input,
          .admin-page select,
          .admin-page textarea,
          .admin-page label {
            color: #111827 !important;
          }
        `}</style>
        <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center gap-8">
                <h1 className="text-xl font-semibold text-gray-900">
                  Admin Panel
                </h1>
                <nav className="flex gap-4">
                  {navItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <Link
                        key={item.path}
                        to={item.path}
                        className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                          isActive
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-500 hover:text-gray-900 hover:bg-gray-50"
                        }`}
                      >
                        <item.icon size={18} />
                        <span className="hidden sm:inline">{item.label}</span>
                      </Link>
                    );
                  })}
                </nav>
              </div>

              <div className="flex items-center gap-4">
                <span className="text-sm text-gray-500 hidden sm:block">
                  {user?.email}
                </span>
                <LogoutButton />
              </div>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </main>
      </div>
    </ConfirmProvider>
  );
}
